import type { TenantConfig } from '@/types/TenantConfig'

const orange = '#fbae35'
const limeGreen = '#7cbf23'
const green = '#759447'

export const virginiazoo: TenantConfig = {
  logo: 'assets/virginiazoo/static/logo.png',
  themeOptions: {
    primaryColor: limeGreen,
    secondaryColor: orange,
    cartHeaderBackgroundColor: orange,
    cartHeaderTextColor: 'black',
    headerBackground: "url('../virginiazoo/static/header.png')",
    footerBackgroundColor: green,
    footerTextColor: 'black',
    logoHeight: '150px',
    headerHeight: '200px',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
  },
}
